import { Tag } from 'antd'
import {
  PaperAnswer,
  PaperBlock,
  PaperQuestion,
  QuestionTypeEnum,
} from 'packages/sdks-next/growp'
import { getLetterByIndex } from 'packages/utils'
import React from 'react'
import styled, { css } from 'styled-components'
import { Analysis } from '../Analysis'
import { useAnswersManagement } from '../context'
import { getReviewById, getValueById, updateAnswers } from '../utils'
import { TrueOrFalseTag } from '../TrueOrFalseTag'
import { QuizMode } from '../types'

export const ChoiceAnswer: React.FC<{
  mainQuestion: PaperQuestion
  block: PaperBlock
}> = ({ mainQuestion, block }) => {
  const { mode, answers, setAnswers, reviews } = useAnswersManagement()
  const { value } = getValueById(answers as PaperAnswer[], mainQuestion.id)
  const { gainScore, result } = getReviewById(reviews, mainQuestion.id)
  const updateValue = (opt: string) => {
    let curValues = value ? [...value] : []
    if (curValues.includes(opt)) {
      curValues = curValues.filter((v) => v !== opt)
    } else {
      if (
        mainQuestion.type === QuestionTypeEnum.SingleChoice &&
        curValues.length !== 0
      ) {
        curValues.splice(0, 1, opt)
      } else {
        curValues.push(opt)
      }
    }
    const newAnswers = updateAnswers(answers, {
      questionId: mainQuestion.id,
      value: curValues,
    })
    setAnswers(newAnswers)
  }
  const options = mainQuestion.options
  return (
    <>
      <>
        {[QuizMode.Review, QuizMode.Reviewed].includes(mode) ? null : (
          <div>
            {options?.map((opt, index) => (
              <StyleTag
                $isStandardAnswer={value ? value.includes(opt) : false}
                key={opt}
                onClick={() => {
                  if (
                    [
                      QuizMode.Completed,
                      QuizMode.Review,
                      QuizMode.Reviewed,
                    ].includes(mode)
                  ) {
                    return
                  }
                  updateValue(opt)
                }}
              >
                {getLetterByIndex(index)}
              </StyleTag>
            ))}
          </div>
        )}
      </>
      {[QuizMode.Answering, QuizMode.Completed, QuizMode.Preview].includes(
        mode
      ) ? null : (
        <Analysis
          mainQuestion={mainQuestion}
          block={block}
          LeftNode={
            <LeftNodeWrapper>
              {options?.map((opt, index) => (
                <React.Fragment key={opt}>
                  {value && value?.includes(opt) ? (
                    <StyleTag
                      $isStandardAnswer={value ? value?.includes(opt) : false}
                      key={opt}
                    >
                      {getLetterByIndex(index)}
                    </StyleTag>
                  ) : null}
                </React.Fragment>
              ))}

              <TrueOrFalseTag
                score={gainScore}
                mode={result}
              />
            </LeftNodeWrapper>
          }
        />
      )}
    </>
  )
}

const StyleTag = styled(Tag)<{ $isStandardAnswer: boolean }>`
  background-color: #fff !important;
  cursor: pointer;
  min-width: 56px;
  text-align: center;
  &&& {
    border-color: ${(props) => props.theme.border.greyNormal};
    padding: 3px 12px;
    font-size: 14px;
    ${(props) =>
      props.$isStandardAnswer
        ? css`
            background-color: ${props.theme.brand._1} !important;
            color: #fff;
            box-sizing: border-box;
            border-color: ${props.theme.brand._1};
          `
        : css`
            color: ${props.theme.text._2};
          `}
    .ant-tag-close-icon {
      color: ${(props) =>
        props.$isStandardAnswer ? '#fff' : props.theme.text._1};
      margin-left: 8px;
    }
  }
`

const LeftNodeWrapper = styled.div`
  height: 32px;
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`
